import React from 'react';
// eslint-disable-next-line
// @ts-ignore
import { Select, Option, SelectProps } from '@ingka/select';
import styled from 'styled-components';

const StyledDropDown = styled(Select)`
  margin: 0 0 10px;
  width: 100%;
`;

interface DropDownOption {
  name: string;
  value: string;
}
export interface DropDownProps extends SelectProps {
  id: string;
  value: string;
  label: string;
  valid: boolean;
  onChange: (val: React.ChangeEvent<HTMLInputElement>) => void;
  options: DropDownOption[];
}

export const StyledDropdown: React.FC<DropDownProps> = ({
  id,
  options,
  label,
  onChange,
  value,
  valid,
  onBlur,
  required,
  describedById,
  req,
  disabled = false,
}): JSX.Element | null => {
  if (!options.length) {
    return null;
  }
  const dropDownOptions = options.map((option, index) => {
    return <Option key={index} name={option.name} value={option.value} />;
  });
  return (
    <StyledDropDown
      id={id}
      label={label}
      onChange={onChange}
      value={value}
      valid={valid?.toString()}
      onBlur={onBlur}
      required={required}
      describedById={describedById}
      req={req}
      hintText={''}
      disabled={disabled}
    >
      {dropDownOptions}
    </StyledDropDown>
  );
};
